import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../Tutorial/SectionChapter';
import SectionHeader from '../../Tutorial/SectionHeader';
import { FindMoreButton } from '../../Home/HomeFeatures/FindMoreButton';
import { tutorialLinks } from '../../../common/urlLinks';

const IndividualBoards = ({ refs }) => {
    const individualBoards = [
        {
            children: (
                <>
                    <ul>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.individualBoards.description.1" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.individualBoards.description.2" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.individualBoards.description.3" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.individualBoards.description.4" />
                            </Typography>
                        </li>
                    </ul>
                    <a href={tutorialLinks.individualBoards}>
                        <FindMoreButton />
                    </a>
                </>
            ),
        },
    ];
    return (
        <>
            <SectionHeader
                refs={refs}
                title={'page.home.feature.individualBoards.tag'}
                id={'section-individualBoards'}
                img={`/static/asset/img/features/table_individuale.png`}
            />
            <SectionChapter
                refs={refs}
                id={'section-individualBoards-section'}
                title={'page.home.feature.individualBoards.description'}
                explanations={individualBoards}
            />
        </>
    );
};

export default IndividualBoards;
